"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var colorsV2_1 = __importDefault(require("../../assets/jss/colorsV2"));
var material_kit_pro_react_1 = require("../../assets/jss/material-kit-pro-react");
var styles = function (theme) {
    var _a, _b;
    var _c;
    return (0, styles_1.makeStyles)({
        container: __assign(__assign({}, material_kit_pro_react_1.container), (_a = { display: 'flex', flexGrow: 1, alignItems: 'center', justifyContent: 'center' }, _a[theme.breakpoints.down('xs')] = {
            paddingLeft: 0,
            paddingRight: 0
        }, _a)),
        forgotPasswordScreen: {
            display: 'flex',
            width: '100%',
            padding: theme.spacing(5, 5.5),
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '37px'
        },
        forgotPasswordCard: {
            borderRadius: '8px',
            background: (_c = colorsV2_1.default.commonColors.backgroundWeb) === null || _c === void 0 ? void 0 : _c.hex(),
            boxShadow: '0px 2px 15px 0px rgba(0, 0, 0, 0.25)'
        },
        forgotPasswordCardContent: (_b = {},
            _b[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(3)
            },
            _b.display = 'flex',
            _b.padding = theme.spacing(5.5),
            _b.flexDirection = 'column',
            _b.justifyContent = 'center',
            _b.alignItems = 'center',
            _b.gap = theme.spacing(5.5),
            _b['&:last-child'] = {
                paddingBottom: theme.spacing(5.5)
            },
            _b),
        titleText: {
            color: colorsV2_1.default.palette.neutralsN900.hex(),
            textAlign: 'center'
        },
        text: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            marginBottom: theme.spacing(3)
        },
        closeText: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
        },
        content: {
            display: 'flex',
            flex: 1,
            flexDirection: 'column',
            alignItems: 'center'
        },
        linkButton: {
            marginBottom: theme.spacing(2),
            width: 'auto'
        },
        mailIcon: {
            fontSize: '120px'
        }
    });
};
exports.default = styles;
//# sourceMappingURL=styles.js.map